import { API_URL } from '../../../app-config/constants';
import { post } from '../request';

const BASE_URL = `${API_URL}/glossary-import`;

export type ExtractedGlossaryTerm = {
    keyword: string;
    explanation: string;
};

export type ExtractGlossaryTermsRequest =
    | {
          text: string;
      }
    | {
          fileName: string;
          mediaType: string;
          data: string;
      };

export function extractTerms(request: ExtractGlossaryTermsRequest) {
    return post<ExtractedGlossaryTerm[]>(`${BASE_URL}/extract`, { postData: request });
}
